import * as React from 'react';
import Box from '@mui/material/Box';
import { GridTable } from '../../Sidebar/SidebarStyles';
import ReportTable from '../ReportTable';
import { fetchOverallStatusReport, generateExportOverallStatusReport } from '../../ApiSevices/ReportApis';
import { Alert, Snackbar } from '@mui/material';
import { ExportQcOverallStatusReport, GetOverallStatusReport } from '../../ApiSevices/QuoteCompareAPI';
import ReportFilterForm from './ReportFilterForm';

interface TableProps {
    displaysidebar: boolean;
}
interface State {
    loading: boolean;
    OSRData: any[];
    page: number;
    rowsPerPage: number;
    totalCount: number;
    OverallStatus: OSRInput;
    snackbarOpen: boolean;
    snackbarMessage: any;
}
interface OSRInput {
    page: number;
    rowsPerPage: number;
    fromDate: any;
    toDate: any;
    brokerName: any
}

class QcOverallStatusReport extends React.Component<TableProps, State> {
    constructor(props: TableProps) {
        super(props);
        this.state = {
            loading: false,
            OSRData: [],
            page: 0,
            rowsPerPage: 100,
            totalCount: 0,
            OverallStatus: {
                page: 0,
                rowsPerPage: 100,
                fromDate: null,
                toDate: null,
                brokerName:""
            },
            snackbarOpen: false,
            snackbarMessage: '',
        };
    }

    fetchData = async (page: number, rowsPerPage: number, OverallStatus: OSRInput) => {
        this.setState({ loading: true });
        try {
            const res = await GetOverallStatusReport(page, rowsPerPage,OverallStatus.brokerName,OverallStatus.fromDate,OverallStatus.toDate)
            if (res?.data?.length > 0) {
                this.setState({
                    OSRData: res.data || [],
                    totalCount: res.totalCount || 0,
                    page,
                    rowsPerPage
                });
            } else {
                this.setState({ OSRData: [] });
                this.showSnackbar('No data available for the selected inputs.', 'error');
            }
        } catch (error) {
            console.error('Error fetching report data:', error);
        } finally {
            this.setState({ loading: false });
        }
    };

    handleFilterSubmit = (OverallStatus: OSRInput) => {
        this.setState({ OverallStatus }, () => {
            this.fetchData(0, this.state.rowsPerPage, OverallStatus);
        });
    };

    handleExportExcel = async (OSRInput: OSRInput) => {
        this.setState({ loading: true });
        try {
            const fileBlob = await ExportQcOverallStatusReport(OSRInput.brokerName, OSRInput.fromDate, OSRInput.toDate);
            const url = window.URL.createObjectURL(fileBlob);
            const link = document.createElement('a');
            link.href = url;
            const filename = `OverallStatusReport_${new Date().toISOString().replace(/[:.]/g, '')}.xlsx`;
            link.setAttribute('download', filename);
            document.body.appendChild(link);
            link.click();
            link.remove();
            window.URL.revokeObjectURL(url);
        } catch (error) {
            console.error('Error exporting Overall Status Report:', error);
        } finally {
            this.setState({ loading: false });
        }
    };

    handlePageChange = (event: unknown, newPage: number) => {
        const { rowsPerPage, OverallStatus } = this.state;
        this.fetchData(newPage, rowsPerPage, OverallStatus);
    };

    handleRowsPerPageChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const newRowsPerPage = parseInt(event.target.value, 10);
        const { OverallStatus } = this.state;
        this.fetchData(0, newRowsPerPage, OverallStatus);
    };

    showSnackbar = (message: string, severity: 'error') => {
        this.setState({ snackbarOpen: true, snackbarMessage: message });
    };

    handleCloseSnackbar = () => {
        this.setState({ snackbarOpen: false });
    };


    render() {
        const { loading, OSRData, totalCount, page, rowsPerPage, snackbarOpen, snackbarMessage } = this.state;
        const { displaysidebar } = this?.props;

        return (
            <>
                {loading && (
                    <Box sx={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        backgroundColor: 'rgba(255, 255, 255, 0.5)',
                        zIndex: 9999
                    }}>
                        <div className="loader"></div>
                    </Box>
                )}

                <Box
                    sx={{
                        height: 'calc(100vh - 40px)',
                    }}
                >
                    <GridTable displaysidebar={displaysidebar}>
                        <>
                            <Box
                                sx={{
                                    padding: '2px 0',
                                    backgroundColor: '#f8f8f8',
                                    borderBottom: '1px solid #ddd',
                                }}
                            >
                                <span
                                    style={{
                                        fontSize: '12px',
                                        fontWeight: 'bold',
                                        color: '#000',
                                        marginLeft: '8px',
                                        textTransform: 'uppercase',
                                    }}
                                >
                                    Overall Status Report
                                </span>
                            </Box>
                            <ReportFilterForm onSubmit={this.handleFilterSubmit} onExport={this.handleExportExcel} showBroker={true} showStatus={false} showFromDate={true} showToDate={true} showGenerteBtn={true} showExcelBtn={true} showSubmitBtn={false} showJobid={false} />

                            <Box sx={{ overflow: 'hidden', height: '100%', width: '100%' }}>
                                <ReportTable
                                    data={OSRData}
                                    totalCount={totalCount}
                                    page={page}
                                    rowsPerPage={rowsPerPage}
                                    onPageChange={this.handlePageChange}
                                    onRowsPerPageChange={this.handleRowsPerPageChange}
                                />
                            </Box>
                            <Snackbar
                                open={snackbarOpen}
                                autoHideDuration={1500}
                                onClose={() => this.setState({ snackbarOpen: false })}
                                anchorOrigin={{ vertical: "top", horizontal: "right" }}
                            >
                                <Alert onClose={() => this.setState({ snackbarOpen: false })} severity="error" sx={{ width: "100%" }}>
                                    {snackbarMessage}
                                </Alert>
                            </Snackbar>

                        </>
                    </GridTable>
                </Box>
            </>
        );
    }
}
export default QcOverallStatusReport;